import React from 'react';
import styled, { css } from 'styled-components';
import { fonts, palette } from 'theme';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import { HelpCircle as HelpCircleIcon } from 'mdi-material-ui';

const VariableInput = styled(Input)`
  ${props =>
    props.size === 'large' &&
    css`
      font-size: 1.5em;
    `}
`;

const LargeTextField = styled(TextField)`
  input {
    font-size: 1.5em;
  }
`;

const MediumTextField = styled(TextField)`
  input {
    font-size: 1.25em;
  }
`;

const LargeSelect = styled(Select)`
  font-size: 1.5em;
`;

const MediumSelect = styled(Select)`
  font-size: 1.25em;
`;

const FormLabelTooltip = styled(({ ...other }) => (
  <>
    {' '}
    <Tooltip placement="top" {...other}>
      <HelpCircleIcon />
    </Tooltip>
  </>
))`
  font-size: 16px;
  vertical-align: middle;
  margin-bottom: 3px;
  color: ${palette.text.hint};
`;

const LargeFormControlLabel = styled(({ label, caption, ...other }) => (
  <FormControlLabel
    classes={{ label: 'label' }}
    label={
      <>
        <>{label}</>
        <Typography variant="subtitle2" component="span" color="inherit">
          {caption}
        </Typography>
      </>
    }
    {...other}
  />
))`
  align-items: flex-start;
  &:not(:last-child) {
    margin-right: 40px;
  }
  & .label {
    padding-top: 6px;
    font-family: ${fonts.headingFamily};
    font-weight: 400;
    font-size: 1.5em;
    & span {
      font-size: 12px;
      font-weight: 400;
    }
  }
`;

const SmallFormLabel = styled(FormLabel)`
  transform: translate(0, 1.5px) scale(0.75);
  transform-origin: top left;
`;

const InlineRadioGroup = styled(RadioGroup)`
  @media (min-width: 480px) {
    flex-direction: row;
  }
`;

const PasswordField = ({
  label,
  placeholder,
  show_password,
  value,
  updateForm,
  isNewPassword,
  helperText,
  size
}) => (
  <FormControl margin="normal" fullWidth>
    <InputLabel shrink={true} htmlFor="adornment-password">
      {label}
    </InputLabel>
    <VariableInput
      autoComplete={isNewPassword ? 'new-password' : 'current-password'}
      id="adornment-password"
      name="password"
      fullWidth
      placeholder={placeholder}
      type={show_password ? show_password : 'password'}
      value={value}
      size={size}
      onChange={event => updateForm({ password: event.target.value })}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="Toggle password visibility"
            onClick={event =>
              updateForm({
                show_password: show_password
                  ? show_password === 'text'
                    ? 'password'
                    : 'text'
                  : 'text'
              })
            }
          >
            {show_password === 'text' ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
    />
    <FormHelperText>{helperText}</FormHelperText>
  </FormControl>
);

export {
  LargeTextField,
  MediumTextField,
  LargeSelect,
  MediumSelect,
  LargeFormControlLabel,
  FormLabelTooltip,
  InlineRadioGroup,
  SmallFormLabel,
  PasswordField,
  VariableInput
};
